var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto"},[_c('c-heading',{attrs:{"my":"2rem"}},[_vm._v("Account Settings")]),_c('c-flex',{attrs:{"bgColor":"white","my":"2rem"}},[_c('sidebar'),_c('profile-setting')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }